export default __webpack_public_path__ + "static/media/051-route.5af7a35c.svg";